export const PROJECTS = [
  {
    id: "summit-home",
    name: "Summit Home Pros",
    category: "Home Services",
    image: "https://images.unsplash.com/photo-1557200134-d1ddc4e349e4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    problem: "Great reviews on Facebook, but no place to send serious customers.",
    solution: "A conversion-first site with instant quote requests and service-area pages.",
  },
  {
    id: "apex-auto",
    name: "Apex Auto Works",
    category: "Automotive",
    image: "https://images.unsplash.com/photo-1541447270888-83e8494f9c06?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    problem: "Customers couldn't tell a premium shop from a backyard mechanic.",
    solution: "A cinematic showcase that makes the workmanship do the selling.",
  },
  {
    id: "olive-lane",
    name: "Olive & Lane Kitchen",
    category: "Restaurants",
    image: "https://images.unsplash.com/photo-1682778418768-16081e4470a1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    problem: "Menus buried in PDF files and no easy way to reserve a table.",
    solution: "A mouth-watering menu experience with one-tap reservations.",
  },
  {
    id: "velvet-studio",
    name: "Velvet Beauty Studio",
    category: "Beauty",
    image: "https://images.unsplash.com/photo-1600948836101-f9ffda59d250?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    problem: "Bookings lived entirely in Instagram DMs — and got lost there.",
    solution: "An elegant brand site with online booking built into every page.",
  },
  {
    id: "meridian-legal",
    name: "Meridian Advisory",
    category: "Professional Services",
    image: "https://images.unsplash.com/photo-1771922748624-b205cf5d002d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    problem: "A dated site that undersold two decades of expertise.",
    solution: "An authoritative presence that turns credibility into consultations.",
  },
  {
    id: "northpeak",
    name: "Northpeak Fitness",
    category: "Other",
    image: "https://images.unsplash.com/photo-1534511902651-6ab0ce131f2a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    problem: "New members had to call during business hours just to join.",
    solution: "A high-energy site where signing up takes under a minute.",
  },
];

export const WORK_FILTERS = [
  "All",
  "Home Services",
  "Automotive",
  "Restaurants",
  "Beauty",
  "Professional Services",
  "Other",
];

export const TESTIMONIALS = [
  {
    name: "Client Name",
    business: "Home Services Company",
    quote: "Placeholder testimonial — this space is reserved for a verified client review. We never fabricate feedback.",
    placeholder: true,
  },
  {
    name: "Client Name",
    business: "Automotive Business",
    quote: "Placeholder testimonial — a real customer quote will appear here once provided and verified.",
    placeholder: true,
  },
  {
    name: "Client Name",
    business: "Restaurant Owner",
    quote: "Placeholder testimonial — reserved for an authentic review from a real project.",
    placeholder: true,
  },
];

export const SERVICES = [
  {
    num: "01",
    title: "Website Design & Development",
    desc: "Custom websites designed around your business — your customers, your services, your goals. Never a template.",
  },
  {
    num: "02",
    title: "Mobile Optimization",
    desc: "Most of your customers are on their phones. Your website should look exceptional on phones, tablets, and desktops.",
  },
  {
    num: "03",
    title: "Conversion Optimization",
    desc: "Strategic layouts and calls-to-action designed to turn visitors into inquiries — not just page views.",
  },
  {
    num: "04",
    title: "Local SEO",
    desc: "We structure your website so search engines can better understand your business, your services, and your service area.",
  },
  {
    num: "05",
    title: "Booking & Lead Systems",
    desc: "Quote requests, appointment booking, contact forms, click-to-call. We make choosing you the easy option.",
  },
  {
    num: "06",
    title: "Website Maintenance",
    desc: "Updates, security, and performance — handled. Your website stays fast, current, and working while you run the business.",
  },
];

export const CONTACT_EMAIL = "mahseri32@gmail.com";
export const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=61576280079121";
